<script>
  export default {
    name: 'card-tile',
    props: {
      icon: {
        type: String,
        required: false
      },
      image: {
        type: String,
        required: false
      },
      link: {
        type: Object,
        default: () => ({})
      },
      primaryColor: {
        type: String,
        required: false
      },
      secondaryColor: {
        type: String,
        required: false
      },
      text: {
        type: String,
        required: false
      }
    }
  }
</script>
<template>
  <v-card v-bind="link" color="transparent" height="100px" flat width="100%" class="wrapper d-flex align-center justify-start">
    <v-card :color="primaryColor" hover rounded :class="`${secondaryColor}--text`" class="background d-flex align-center justify-space-between" height="100%" width="90%"> </v-card>
    <v-card color="transparent" flat class="content-container d-flex align-center justify-center">
      <v-sheet color="yellow" height="90%" rounded class="media-container d-flex align-center justify-center">
        <v-img v-if="image" contain height="auto" :src="image" width="100%" class="rounded-lg"></v-img>
        <v-icon v-else-if="icon" :color="secondaryColor" large>{{ icon }}</v-icon>
      </v-sheet>
      <v-card-text class="content d-flex align-center justify-start">
        <v-sheet color="transparent" :class="`${secondaryColor}--text`" class="cardTitle font-weight-black text-wrap mr-auto">
          {{ text }}
        </v-sheet>
      </v-card-text>
    </v-card>
  </v-card>
</template>
<style scoped>
  .wrapper {
    position: relative;
    cursor: pointer;
    transition: transform 0.5s ease-in-out;
    transform: scale(1);
  }
  .wrapper:hover {
    transition: transform 0.5s ease-in-out;
    transform: scale(1.05);
  }

  .background {
    /* margin-left: auto; */
    position: absolute;
    left: 40px;
  }
  .content-container {
    position: relative;
    height: 100%;
  }
  .cardTitle {
    font-size: 1.75em;
    overflow-wrap: break-word;
  }
  .media-container {
    position: relative;
    overflow: hidden;
    height: 80%;
    max-height: 80%;
    width: 100%;
    max-width: 120px;
    object-fit: cover;
    object-position: center center;
    padding: 4px;
    -webkit-box-shadow: 10px 10px 5px -6px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 10px 10px 5px -6px rgba(0, 0, 0, 0.75);
    box-shadow: 10px 10px 5px -6px rgba(0, 0, 0, 0.75);
  }

  .media-container > * {
    max-height: 100%;
    max-width: 100%;
    height: 100%;
    width: 100%;
  }
</style>
